import { IRegion } from '@alberta/konexi-shared';
import { Inject, Injectable, NgZone } from '@angular/core';
import { RegionChannel } from 'src/app/business/user-management/contracts/region-channel';
import { IAppController } from 'src/app/common/contracts/controller/app-controller';
import { IDispatcher } from 'src/app/common/contracts/dispatch/dispatcher';
import { IPlatformSync, PlatformSyncToken } from 'src/app/common/contracts/sync/platform-sync';
import { AppController } from 'src/app/common/controller/app-controller';
import { Dispatcher } from 'src/app/common/dispatch/dispatcher';

import { RegionModelName } from '../../models/model-names';
import { SyncProgressEvent } from '../../models/sync-progress-event';
import { EventService } from '../event.service';
import { SyncService } from './sync.service';
import { TrackerService } from '@services/tracker.service';

@Injectable()
export class RegionSyncService extends SyncService<IRegion> {
  constructor(
    @Inject(AppController) appController: IAppController,
    @Inject(Dispatcher) dispatcher: IDispatcher<IRegion>,
    eventService: EventService<SyncProgressEvent>,
    ngZone: NgZone,
    @Inject(PlatformSyncToken) platformSync: IPlatformSync
  ) {
    super(RegionModelName, appController, dispatcher, eventService, ngZone, platformSync);
  }

  public canSync(channel: string): boolean {
    return channel === RegionChannel.CREATE || channel === RegionChannel.EDIT || channel === RegionChannel.DELETE;
  }
}
